$(document).ready(function(){
  /* shop-by-look page: Add to cart add on product with main product : Start */
  
  $('body').on("change", ".cl_category_box input[type='checkbox']", function(){
    let allUnchecked = false;
    
    $(this).closest(".cl_shop_category_block").find(".add_on_btn").removeClass("cl_disabled"); 
    $(this).closest(".cl_shop_category_block").find(".cl_category_box input[type='checkbox']").each(function() {
      if ($(this).prop('checked')==true){
        allUnchecked = true;
      }
    });
    $(this).closest(".cl_shop_category_block").find(".add_on_btn").text("Add Selected to Cart"); 
    if( !allUnchecked ){
      $(this).closest(".cl_shop_category_block").find(".add_on_btn").addClass("cl_disabled"); 
      $(this).closest(".cl_shop_category_block").find(".add_on_btn").text("Select products"); 
    }       
  })
  
  /* On variant change call function :Start */
  /*
  function varaintSelect(form){
    var fieldsets = form.find('.variant-lists').toArray();
    //var getVariantData = JSON.parse(form.find('[type="application/json"]').text());
    var options = [];
    
    $.each(fieldsets, function (i, v){
      var value = $(v).find("input[type='radio']:checked").val();
      options.push(value);
    });
    
    var currentVariant;
    // $.each(getVariantData, function (i, variant){
    //   var lll = 0;
    //   $.each(variant.options, function (index, option){
    //     if(options[index] !== option){
    //       lll = 1;
    //     }
    //   });
      
    //   if(lll == 0){
    //     currentVariant = variant;
    //   }
    // });

    if(typeof currentVariant !== "undefined" ){
      console.log( currentVariant );
     // form.find(".variant-lists .selected_option").text(currentVariant.title);
      form.closest(".cl_shop_category_block").find(".cl_shop_top .cl_shop_category_info input[type='checkbox']").val(currentVariant.id);
      form.closest(".cl_shop_category_block").find(".cl_shop_top .cl_shop_category_name p").text("$"+currentVariant.price/100);
    }
    
    //console.log( options );
  } */
  /* function: End */

  /* on variant change events */
  // $("body").on("change", ".variant-lists input45", function(){
  //   let variantID = $(this).data("variant-id");
  //   $(this).closest(".variant-lists").find(".selected_option").text($(this).val());
    
  //   if( typeof variantID !="undefined" && variantID !="" ){
  //     $(this).closest(".cl_shop_category_block").find(".cl_shop_top .cl_shop_category_info input[type='checkbox']").val(variantID);
  //     $(this).closest(".cl_shop_category_block").find(".cl_shop_top .cl_shop_category_name p").text($(this).data("variant-price"));     
  //   }
      
  //   var form = $(this).closest('form');
  //   varaintSelect(form);
  // })
  function lineItemUpdate(){
     $.get(`/cart?section_id=cart-drawer`, function(data) {
       console.log( $(data) );
       console.log( $(data).find("#Cart-Drawer").data("item_count") );
       $(".thb-item-count").text($(data).find("#Cart-Drawer").data("item_count"))
       $("#Cart-Drawer").html( $(data).find("#Cart-Drawer").html());
     })
    
    if (document.getElementById('Cart-Drawer')) {
      document.getElementById('Cart-Drawer').classList.add('active');
      document.body.classList.add('open-cart');
      document.body.classList.add('open-cc');
      
      if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
        document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
      }
      dispatchCustomEvent('cart-drawer:open');
      setTimeout(function () {
        new CartDrawer(); }, 2000);
    }
  }
  
  // $('body').on("click", ".product-cart-item .remove", function(e){
  //   e.preventDefault();
  //   let line_item = $(this).data("index");
  //   $.ajax({
  //     type: 'POST',
  //     url: '/cart/update.js',
  //     dataType: 'json',
  //     data: qtyArr,
  //     success: function(data){
        
  //     },
  //     error: function(error){
        
  //     }
  //   })
  //   console.log(line_item);
  // })

  $('body').on("click", ".add_on_btn", function(e){
    e.preventDefault();        
    var pdpWithAddOnData = { items: [] };
    
    if( $(this).closest(".cl_shop_category_block").find(".cl_category_box input[type='checkbox']").length > 0 ){
      
      $(this).closest(".cl_shop_category_block").find(".cl_category_box input[type='checkbox']").each(function(index, element){
        
        if ($(element).prop('checked')==true){
          let addOnProducts= {};
          let variantId = $(element).val(); // let properties = {  "_Bundle_pack" : ranNum }
          
          addOnProducts['id'] = variantId;          
          addOnProducts['quantity'] = 1;          
          pdpWithAddOnData.items.push(addOnProducts);      
        }
      })
      
      if( pdpWithAddOnData.items.length > 0 ){
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: pdpWithAddOnData,
          success: function(cart){  
            // lineItemUpdate();  
             $.get(`/cart?section_id=cart-drawer`, function(data) {
               $(".thb-item-count").text($(data).find("#Cart-Drawer").data("item_count"))
               $("#Cart-Drawer").html( $(data).find("#Cart-Drawer").html());
             });
              
            
              dispatchCustomEvent('cart:item-added', {
                product: cart.hasOwnProperty('items') ? cart.items[0] : cart
              });  
             

            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              document.body.classList.add('open-cc');
              
              if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
                document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
              }
              dispatchCustomEvent('cart-drawer:open');
            }
          setTimeout(function(){
            if (typeof CartDrawer !== "undefined") {
              new CartDrawer();
            }
        },500)
          },
          error: function(error) {
            console.log(error)
          }
        });
      }
    }
  });
/* shop-by-look page: End */
  jQuery(function() {
    jQuery('.custom-swatch :radio').change(function() {
      var optionIndex = jQuery(this).closest('.custom-swatch').attr('data-option-index');
      var optionValue = jQuery(this).val();  
      
      if( optionValue != null ){
        jQuery(this)
        .closest('form')
        .find('.single-option-selector')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');
        
        jQuery(this).closest(".variant-lists").find(".selected_option").text(optionValue);  
      }
    });
  });
})

/*
const selectCallbackVariant = function(variant, selector){
  console.log("variant changes", variant)
    if( variant != null && variant.available ){
     //console.log("variant", variant);
    }else{
      
    }  
  } */